import { render, staticRenderFns } from "./BuyerCenter.vue?vue&type=template&id=1ccd3b0a&scoped=true&"
import script from "./BuyerCenter.vue?vue&type=script&lang=js&"
export * from "./BuyerCenter.vue?vue&type=script&lang=js&"
import style0 from "./BuyerCenter.vue?vue&type=style&index=0&id=1ccd3b0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccd3b0a",
  null
  
)

export default component.exports